module.exports = "/assets/js/d10aa14087c25bd63f184179122f20d9.svg";